import { Table } from "react-bootstrap";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const FieldLevelRiskTable = ({ userActivityLoader, userActivity = [] }) => {
  return (
    <>
      {userActivityLoader ? (
        <div
          className="hstack justify-content-center"
          style={{ height: "calc(100vh - 500px)" }}
        >
          <PageLoader />
        </div>
      ) : (
        <Table className="m-0 custom-table" hover striped>
          <thead className="position-sticky top-0 z-1">
            <tr>
              <th>Form</th>
              <th>Field</th>
              <th>Query</th>
              <th>Open</th>
              <th>Top Category</th>
              <th>Edit Check</th>
              <th>Avg. Resulation</th>
              <th>Risk</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Adverse Events</td>
              <td>AE Start Date</td>
              <td>30</td>
              <td>8</td>
              <td>Missing Data</td>
              <td>---</td>
              <td>9.2 d</td>
              <td>High</td>
            </tr>
          </tbody>
        </Table>
      )}
    </>
  );
};

export default FieldLevelRiskTable;
